import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
  UpdateIdCompletedInitGetRequestModel,
  UpdateIdCompletedInitGetResponseModel
} from "@/features/user/services/update-id-completed-model";

export class UpdateIdCompletedApi {
  /**
   * 利用者ID更新完了ページ表示前処理API
   */
  public updateIdCompletedInit = async (
    param: UpdateIdCompletedInitGetRequestModel
  ): Promise<UpdateIdCompletedInitGetResponseModel> => {
    const path = `/api/update_id_completed/init`;

    const res = await ApiClient.instance.get<UpdateIdCompletedInitGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
